export const apiCreateUser = "/1.0/user/create"
export const apiListUser = "/1.0/user/list"
export const apiLock = "/1.0/user/lock"
export const apiUnlock = "/1.0/user/unlock"
export const apiLeaderLock = "/1.0/wsm/leader/user/lock"
export const apiLeaderUnlock = "/1.0/wsm/leader/user/unlock"
export const apidropdownlistCustomers = "/1.0/wsm/dropdownlist/customers"
export const apiGetUser = "/1.0/user/list/parent"

export const apiCreateUserLeader = "/1.0/wsm/leader/user/create"
export const apiExport = "/1.0/wsm/leader/user/export"
export const apiListUserLeader = "/1.0/wsm/leader/user/list"
export const apiListLeaderUser = "/1.0/user/list/leader"
